var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-reports" }, [
    _c("div", { staticClass: "filter-bar" }, [
      _c(
        "div",
        { staticClass: "filter-bar__left" },
        [
          _c("a-icon", {
            staticClass: "filter-bar__icon",
            attrs: { type: "bar-chart" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "filter-bar__title" }, [
            _vm._v(_vm._s(_vm.$t("task_reports.title"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "filter-bar__right" }, [
        _c(
          "div",
          { staticClass: "filter-item" },
          [
            _c("span", { staticClass: "filter-item__label" }, [
              _vm._v(_vm._s(_vm.$t("task_reports.date"))),
            ]),
            _vm._v(" "),
            _c("a-range-picker", {
              staticStyle: { width: "240px" },
              attrs: {
                value: _vm.dateRange,
                format: "DD.MM.YYYY",
                allowClear: false,
                size: "small",
                ranges: _vm.quickDateRanges,
                disabledDate: _vm.disabledDate,
              },
              on: { change: _vm.handleDateRangeChange },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-item" },
          [
            _c("span", { staticClass: "filter-item__label" }, [
              _vm._v(_vm._s(_vm.$t("task_reports.workflow"))),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticStyle: { width: "170px" },
                attrs: {
                  placeholder: _vm.$t("task_reports.select"),
                  size: "small",
                },
                on: { change: _vm.handleWorkflowChange },
                model: {
                  value: _vm.selectedWorkflowId,
                  callback: function ($$v) {
                    _vm.selectedWorkflowId = $$v
                  },
                  expression: "selectedWorkflowId",
                },
              },
              _vm._l(_vm.availableWorkflows, function (wf) {
                return _c(
                  "a-select-option",
                  { key: wf._id, attrs: { value: wf._id } },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(wf.title) +
                        "\n                    "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-item" },
          [
            _c("span", { staticClass: "filter-item__label" }, [
              _vm._v(_vm._s(_vm.$t("task_reports.agent"))),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticStyle: { width: "200px" },
                attrs: {
                  mode: "multiple",
                  placeholder: _vm.$t("task_reports.all"),
                  maxTagCount: 1,
                  allowClear: "",
                  size: "small",
                },
                on: { change: _vm.handleUserFilterChange },
                model: {
                  value: _vm.selectedUsers,
                  callback: function ($$v) {
                    _vm.selectedUsers = $$v
                  },
                  expression: "selectedUsers",
                },
              },
              _vm._l(_vm.availableUsers, function (user) {
                return _c(
                  "a-select-option",
                  { key: user._id, attrs: { value: user._id } },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(user.name) +
                        "\n                    "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    !_vm.selectedWorkflowId
      ? _c(
          "div",
          { staticClass: "empty-workflow" },
          [
            _c("a-icon", {
              staticClass: "empty-workflow__icon",
              attrs: { type: "folder-open" },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "empty-workflow__text" }, [
              _vm._v(
                _vm._s(_vm.$t("task_reports.select_workflow_to_view_reports"))
              ),
            ]),
          ],
          1
        )
      : _vm.isLoading
      ? _c("div", { staticClass: "report-body" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
        ])
      : _vm.reportData
      ? _c("div", { staticClass: "report-body" }, [
          _c("div", { staticClass: "section-row section-row--cards" }, [
            _c("div", { staticClass: "stat-card stat-card--blue" }, [
              _c("div", { staticClass: "stat-card__number" }, [
                _vm._v(_vm._s(_vm.reportData.summary.totalCreated)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card__label" }, [
                _vm._v(_vm._s(_vm.$t("task_reports.created_task"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card__sub" }, [
                _vm._v(_vm._s(_vm.dateRangeLabel)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat-card stat-card--orange" }, [
              _c("div", { staticClass: "stat-card__number" }, [
                _vm._v(_vm._s(_vm.reportData.summary.totalChanged)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card__label" }, [
                _vm._v(_vm._s(_vm.$t("task_reports.updated_task"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card__sub" }, [
                _vm._v(_vm._s(_vm.dateRangeLabel)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-section" },
            [
              _c("div", { staticClass: "report-section__title" }, [
                _vm._v(
                  _vm._s(_vm.$t("task_reports.assigned_tasks_by_personnel"))
                ),
              ]),
              _vm._v(" "),
              _vm.reportData.summary.byPersonnel.length > 0
                ? _c("a-table", {
                    attrs: {
                      columns: _vm.personnelColumns,
                      dataSource: _vm.reportData.summary.byPersonnel,
                      pagination: false,
                      rowKey: function (r, i) {
                        return (r.userId || "u") + "_" + i
                      },
                      size: "small",
                      bordered: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "userName",
                          fn: function (text, record) {
                            return [
                              _c(
                                "div",
                                { staticClass: "user-cell" },
                                [
                                  record.gravatar
                                    ? _c("a-avatar", {
                                        attrs: {
                                          src: record.gravatar,
                                          size: 22,
                                        },
                                      })
                                    : _c("a-avatar", {
                                        attrs: { size: 22, icon: "user" },
                                      }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(text))]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "createdCount",
                          fn: function (text) {
                            return [
                              _c("a-tag", { attrs: { color: "blue" } }, [
                                _vm._v(_vm._s(text)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      520420601
                    ),
                  })
                : _c("div", { staticClass: "mini-empty" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "task_reports.no_assigned_task_found_in_date_range"
                        )
                      )
                    ),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-section" },
            [
              _c("div", { staticClass: "report-section__title" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("task_reports.updated_tasks")) +
                    "\n                    "
                ),
                _vm.reportData.summary.changedTasks.length > 0
                  ? _c("span", { staticClass: "report-section__count" }, [
                      _vm._v(
                        "\n                        (" +
                          _vm._s(_vm.reportData.summary.changedTasks.length) +
                          ")\n                    "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.reportData.summary.changedTasks.length > 0
                ? _c("a-table", {
                    attrs: {
                      columns: _vm.changedColumns,
                      dataSource: _vm.reportData.summary.changedTasks,
                      pagination:
                        _vm.reportData.summary.changedTasks.length > 10
                          ? {
                              pageSize: 10,
                              size: "small",
                              showSizeChanger: true,
                              pageSizeOptions: ["10", "20", "50", "100"],
                            }
                          : false,
                      rowKey: function (r, i) {
                        return (r.taskId || "") + "_" + i
                      },
                      size: "small",
                      bordered: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "taskTitle",
                          fn: function (text, record) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "task-link",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openTaskDetail(record)
                                    },
                                  },
                                },
                                [
                                  _c("strong", [_vm._v(_vm._s(text))]),
                                  _vm._v(" "),
                                  record.customId
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "text-muted",
                                          staticStyle: { "margin-left": "4px" },
                                        },
                                        [_vm._v("#" + _vm._s(record.customId))]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "currentStageName",
                          fn: function (text, record) {
                            return [
                              _c(
                                "a-tooltip",
                                { attrs: { title: text } },
                                [
                                  _c(
                                    "a-tag",
                                    {
                                      staticClass: "stage-tag-ellipsis",
                                      attrs: {
                                        color: record.currentStageColor,
                                      },
                                    },
                                    [_vm._v(_vm._s(text))]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "updatedAt",
                          fn: function (text) {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.formatDateTime(text)) +
                                  "\n                    "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2623138673
                    ),
                  })
                : _c("div", { staticClass: "mini-empty" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "task_reports.no_updated_task_found_in_date_range"
                        )
                      )
                    ),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-section" },
            [
              _c("div", { staticClass: "report-section__title" }, [
                _vm._v(
                  _vm._s(_vm.$t("task_reports.task_distribution_by_agent"))
                ),
              ]),
              _vm._v(" "),
              _vm.agentTableData.length > 0
                ? _c("a-table", {
                    attrs: {
                      columns: _vm.agentTableColumns,
                      dataSource: _vm.agentTableData,
                      pagination: false,
                      rowKey: function (r) {
                        return r.userId || "unassigned"
                      },
                      size: "small",
                      bordered: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "userName",
                          fn: function (text, record) {
                            return [
                              _c(
                                "div",
                                { staticClass: "user-cell" },
                                [
                                  record.gravatar
                                    ? _c("a-avatar", {
                                        attrs: {
                                          src: record.gravatar,
                                          size: 22,
                                        },
                                      })
                                    : _c("a-avatar", {
                                        attrs: { size: 22, icon: "user" },
                                      }),
                                  _vm._v(" "),
                                  _c("strong", [_vm._v(_vm._s(text))]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "totalTasks",
                          fn: function (text) {
                            return [_c("strong", [_vm._v(_vm._s(text))])]
                          },
                        },
                      ],
                      null,
                      false,
                      4106180187
                    ),
                  })
                : _c("div", { staticClass: "mini-empty" }, [
                    _vm._v(
                      _vm._s(_vm.$t("task_reports.no_assigned_task_found"))
                    ),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-section" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "report-section__title report-section__title--flex",
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("task_reports.timeline")))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tl-inline-controls" },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            placeholder: _vm.$t("task_reports.select"),
                            showSearch: "",
                            allowClear: "",
                            size: "small",
                            filterOption: _vm.filterUserOption,
                          },
                          on: { change: _vm.loadTimeline },
                          model: {
                            value: _vm.timelineUserId,
                            callback: function ($$v) {
                              _vm.timelineUserId = $$v
                            },
                            expression: "timelineUserId",
                          },
                        },
                        [
                          _c(
                            "a-select-option",
                            {
                              key: "unassigned",
                              attrs: { value: "unassigned" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("task_reports.unassigned_tasks")
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.availableUsers, function (user) {
                            return _c(
                              "a-select-option",
                              { key: user._id, attrs: { value: user._id } },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(user.name) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "a-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.timelineView,
                            callback: function ($$v) {
                              _vm.timelineView = $$v
                            },
                            expression: "timelineView",
                          },
                        },
                        [
                          _c("a-radio-button", { attrs: { value: "gantt" } }, [
                            _vm._v(_vm._s(_vm.$t("task_reports.gantt"))),
                          ]),
                          _vm._v(" "),
                          _c("a-radio-button", { attrs: { value: "table" } }, [
                            _vm._v(_vm._s(_vm.$t("task_reports.table"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.isTimelineLoading
                ? _c("div", { staticClass: "tl-loading" }, [
                    _c("div", { staticClass: "skel-row" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "skel-row skel-row--short" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "skel-row" }),
                  ])
                : [
                    _vm.timelineData && _vm.timelineData.tasks.length > 0
                      ? _c("div", [
                          _vm.timelineView === "gantt"
                            ? _c(
                                "div",
                                { staticClass: "gantt-wrap" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "gantt-legend" },
                                    _vm._l(_vm.ganttLegend, function (leg) {
                                      return _c(
                                        "span",
                                        {
                                          key: leg.name,
                                          staticClass: "gantt-legend__item",
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "gantt-legend__dot",
                                            style: { background: leg.color },
                                          }),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(leg.name) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.groupedTimelineTasks,
                                    function (group, gi) {
                                      return _c(
                                        "div",
                                        {
                                          key: "g" + gi,
                                          staticClass: "gantt-group",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "gantt-group__head",
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "gantt-group__dot",
                                                style: {
                                                  background: group.stageColor,
                                                },
                                              }),
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(group.stageName) +
                                                  "\n                                    "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "gantt-group__cnt",
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        group.tasks.length
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(group.tasks, function (task) {
                                            return _c(
                                              "div",
                                              {
                                                key: task.taskId,
                                                staticClass: "gantt-row",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "gantt-row__label",
                                                    attrs: {
                                                      title: task.taskTitle,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "gantt-row__title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(task.taskTitle)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    task.customId
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "gantt-row__id",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                task.customId
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "gantt-row__bars",
                                                  },
                                                  _vm._l(
                                                    task.stageHistory,
                                                    function (stg, si) {
                                                      return _c(
                                                        "a-tooltip",
                                                        {
                                                          key: si,
                                                          attrs: {
                                                            placement: "top",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "title" },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    stg.stageName
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("br"),
                                                              _vm._v(
                                                                "\n                                                " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "task_reports.entry"
                                                                    )
                                                                  ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    _vm.formatDateTime(
                                                                      stg.enteredAt
                                                                    )
                                                                  )
                                                              ),
                                                              _c("br"),
                                                              _vm._v(" "),
                                                              stg.leftAt
                                                                ? [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "task_reports.exit"
                                                                        )
                                                                      ) +
                                                                        ": " +
                                                                        _vm._s(
                                                                          _vm.formatDateTime(
                                                                            stg.leftAt
                                                                          )
                                                                        )
                                                                    ),
                                                                    _c("br"),
                                                                  ]
                                                                : [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "task_reports.still_in_this_stage"
                                                                        )
                                                                      )
                                                                    ),
                                                                    _c("br"),
                                                                  ],
                                                              _vm._v(
                                                                "\n                                                " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "task_reports.duration"
                                                                    )
                                                                  ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    _vm.formatDuration(
                                                                      stg.durationDays,
                                                                      stg.durationHours
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ],
                                                            2
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "gantt-seg",
                                                              style: {
                                                                background:
                                                                  stg.stageColor,
                                                                flex: _vm.getSegmentFlex(
                                                                  stg
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              stg.durationDays >
                                                                0 ||
                                                              stg.durationHours >
                                                                2
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "gantt-seg__txt",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                    " +
                                                                          _vm._s(
                                                                            _vm.formatDurationShort(
                                                                              stg.durationDays,
                                                                              stg.durationHours
                                                                            )
                                                                          ) +
                                                                          "\n                                                "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ]
                                            )
                                          }),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.timelineView === "table"
                            ? _c(
                                "div",
                                [
                                  _c("a-table", {
                                    attrs: {
                                      columns: _vm.timelineTableColumns,
                                      dataSource: _vm.timelineData.tasks,
                                      pagination: {
                                        pageSize: 15,
                                        size: "small",
                                      },
                                      rowKey: function (r) {
                                        return r.taskId
                                      },
                                      size: "small",
                                      bordered: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "taskTitle",
                                          fn: function (text, record) {
                                            return [
                                              _c("strong", [
                                                _vm._v(_vm._s(text)),
                                              ]),
                                              _vm._v(" "),
                                              record.customId
                                                ? _c(
                                                    "span",
                                                    { staticClass: "tl-cid" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(record.customId)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: "currentStage",
                                          fn: function (text, record) {
                                            return [
                                              record.currentStage
                                                ? _c(
                                                    "a-tag",
                                                    {
                                                      attrs: {
                                                        color:
                                                          record.currentStage
                                                            .stageColor,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            record.currentStage
                                                              .stageName
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: "stageHistory",
                                          fn: function (text, record) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "stage-flow" },
                                                _vm._l(
                                                  record.stageHistory,
                                                  function (stg, si) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: si,
                                                        staticClass:
                                                          "stage-flow__item",
                                                      },
                                                      [
                                                        _c(
                                                          "a-tag",
                                                          {
                                                            attrs: {
                                                              color:
                                                                stg.stageColor,
                                                              size: "small",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  stg.stageName
                                                                ) +
                                                                " (" +
                                                                _vm._s(
                                                                  _vm.formatDuration(
                                                                    stg.durationDays,
                                                                    stg.durationHours
                                                                  )
                                                                ) +
                                                                ")\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        si <
                                                        record.stageHistory
                                                          .length -
                                                          1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "stage-flow__arrow",
                                                              },
                                                              [_vm._v("→")]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2648852660
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm.timelineUserId && !_vm.isTimelineLoading
                      ? _c("div", { staticClass: "mini-empty" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "task_reports.no_active_task_found_for_agent"
                                )
                              ) +
                              "\n                    "
                          ),
                        ])
                      : _vm.isAllTimelineLoading
                      ? _c("div", { staticClass: "all-tl-loading" }, [
                          _c(
                            "div",
                            { staticClass: "all-tl-loading__spinner" },
                            [
                              _c("div", {
                                staticClass: "all-tl-loading__ring",
                              }),
                              _vm._v(" "),
                              _c("a-icon", {
                                staticClass: "all-tl-loading__icon",
                                attrs: { type: "bar-chart" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h3", { staticClass: "all-tl-loading__title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("task_reports.report_being_prepared")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "all-tl-loading__subtitle" }, [
                            _vm._v(_vm._s(_vm.$t("task_reports.please_wait"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "all-tl-loading__progress" },
                            [
                              _c("a-progress", {
                                attrs: {
                                  percent: _vm.allTimelineProgress,
                                  status: "active",
                                  strokeColor: {
                                    from: "#4f6af6",
                                    to: "#3b52d4",
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "all-tl-loading__detail" },
                                [_vm._v(_vm._s(_vm.allTimelineProgressText))]
                              ),
                            ],
                            1
                          ),
                        ])
                      : !_vm.timelineUserId && _vm.allTimelineData
                      ? [
                          _vm.allTimelineData.length > 0
                            ? _c("div", [
                                _vm.timelineView === "gantt"
                                  ? _c(
                                      "div",
                                      { staticClass: "gantt-wrap" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "gantt-legend" },
                                          _vm._l(
                                            _vm.allGanttLegend,
                                            function (leg) {
                                              return _c(
                                                "span",
                                                {
                                                  key: leg.name,
                                                  staticClass:
                                                    "gantt-legend__item",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "gantt-legend__dot",
                                                    style: {
                                                      background: leg.color,
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(leg.name) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.allTimelineData,
                                          function (agentGroup) {
                                            return _c(
                                              "div",
                                              {
                                                key: agentGroup.userId,
                                                staticClass:
                                                  "gantt-agent-section",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "gantt-agent-section__head",
                                                  },
                                                  [
                                                    agentGroup.gravatar
                                                      ? _c("a-avatar", {
                                                          attrs: {
                                                            src: agentGroup.gravatar,
                                                            size: 22,
                                                          },
                                                        })
                                                      : _c("a-avatar", {
                                                          attrs: {
                                                            size: 22,
                                                            icon: "user",
                                                          },
                                                        }),
                                                    _vm._v(" "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          agentGroup.userName
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "gantt-agent-section__cnt",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              agentGroup.tasks
                                                                .length
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "task_reports.tasks_count"
                                                              )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.groupTasksByStage(
                                                    agentGroup.tasks
                                                  ),
                                                  function (group, gi) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key:
                                                          agentGroup.userId +
                                                          "_g" +
                                                          gi,
                                                        staticClass:
                                                          "gantt-group",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "gantt-group__head",
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "gantt-group__dot",
                                                              style: {
                                                                background:
                                                                  group.stageColor,
                                                              },
                                                            }),
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  group.stageName
                                                                ) +
                                                                "\n                                            "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "gantt-group__cnt",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(" +
                                                                    _vm._s(
                                                                      group
                                                                        .tasks
                                                                        .length
                                                                    ) +
                                                                    ")"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          group.tasks,
                                                          function (task) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: task.taskId,
                                                                staticClass:
                                                                  "gantt-row",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "gantt-row__label",
                                                                    attrs: {
                                                                      title:
                                                                        task.taskTitle,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "gantt-row__title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            task.taskTitle
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    task.customId
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "gantt-row__id",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                task.customId
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "gantt-row__bars",
                                                                  },
                                                                  _vm._l(
                                                                    task.stageHistory,
                                                                    function (
                                                                      stg,
                                                                      si
                                                                    ) {
                                                                      return _c(
                                                                        "a-tooltip",
                                                                        {
                                                                          key: si,
                                                                          attrs:
                                                                            {
                                                                              placement:
                                                                                "top",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "template",
                                                                            {
                                                                              slot: "title",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "strong",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      stg.stageName
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "br"
                                                                              ),
                                                                              _vm._v(
                                                                                "\n                                                        " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "task_reports.entry"
                                                                                    )
                                                                                  ) +
                                                                                  ": " +
                                                                                  _vm._s(
                                                                                    _vm.formatDateTime(
                                                                                      stg.enteredAt
                                                                                    )
                                                                                  )
                                                                              ),
                                                                              _c(
                                                                                "br"
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              stg.leftAt
                                                                                ? [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "task_reports.exit"
                                                                                        )
                                                                                      ) +
                                                                                        ": " +
                                                                                        _vm._s(
                                                                                          _vm.formatDateTime(
                                                                                            stg.leftAt
                                                                                          )
                                                                                        )
                                                                                    ),
                                                                                    _c(
                                                                                      "br"
                                                                                    ),
                                                                                  ]
                                                                                : [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "task_reports.still_in_this_stage"
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                    _c(
                                                                                      "br"
                                                                                    ),
                                                                                  ],
                                                                              _vm._v(
                                                                                "\n                                                        " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "task_reports.duration"
                                                                                    )
                                                                                  ) +
                                                                                  ": " +
                                                                                  _vm._s(
                                                                                    _vm.formatDuration(
                                                                                      stg.durationDays,
                                                                                      stg.durationHours
                                                                                    )
                                                                                  ) +
                                                                                  "\n                                                    "
                                                                              ),
                                                                            ],
                                                                            2
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "gantt-seg",
                                                                              style:
                                                                                {
                                                                                  background:
                                                                                    stg.stageColor,
                                                                                  flex: _vm.getSegmentFlex(
                                                                                    stg
                                                                                  ),
                                                                                },
                                                                            },
                                                                            [
                                                                              stg.durationDays >
                                                                                0 ||
                                                                              stg.durationHours >
                                                                                2
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "gantt-seg__txt",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                                            " +
                                                                                          _vm._s(
                                                                                            _vm.formatDurationShort(
                                                                                              stg.durationDays,
                                                                                              stg.durationHours
                                                                                            )
                                                                                          ) +
                                                                                          "\n                                                        "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        2
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.timelineView === "table"
                                  ? _c(
                                      "div",
                                      [
                                        _c("a-table", {
                                          attrs: {
                                            columns:
                                              _vm.allTimelineTableColumns,
                                            dataSource:
                                              _vm.allTimelineTableDataFlat,
                                            pagination: {
                                              pageSize: 15,
                                              size: "small",
                                              showSizeChanger: true,
                                              pageSizeOptions: [
                                                "15",
                                                "30",
                                                "50",
                                                "100",
                                              ],
                                            },
                                            rowKey: function (r, i) {
                                              return (r.taskId || "") + "_" + i
                                            },
                                            size: "small",
                                            bordered: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "agentName",
                                                fn: function (text, record) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "user-cell",
                                                      },
                                                      [
                                                        record.agentGravatar
                                                          ? _c("a-avatar", {
                                                              attrs: {
                                                                src: record.agentGravatar,
                                                                size: 22,
                                                              },
                                                            })
                                                          : _c("a-avatar", {
                                                              attrs: {
                                                                size: 22,
                                                                icon: "user",
                                                              },
                                                            }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(_vm._s(text)),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "taskTitle",
                                                fn: function (text, record) {
                                                  return [
                                                    _c("strong", [
                                                      _vm._v(_vm._s(text)),
                                                    ]),
                                                    _vm._v(" "),
                                                    record.customId
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tl-cid",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                record.customId
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "currentStage",
                                                fn: function (text, record) {
                                                  return [
                                                    record.currentStage
                                                      ? _c(
                                                          "a-tag",
                                                          {
                                                            attrs: {
                                                              color:
                                                                record
                                                                  .currentStage
                                                                  .stageColor,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  record
                                                                    .currentStage
                                                                    .stageName
                                                                ) +
                                                                "\n                                        "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "stageHistory",
                                                fn: function (text, record) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "stage-flow",
                                                      },
                                                      _vm._l(
                                                        record.stageHistory,
                                                        function (stg, si) {
                                                          return _c(
                                                            "span",
                                                            {
                                                              key: si,
                                                              staticClass:
                                                                "stage-flow__item",
                                                            },
                                                            [
                                                              _c(
                                                                "a-tag",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      stg.stageColor,
                                                                    size: "small",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        stg.stageName
                                                                      ) +
                                                                      " (" +
                                                                      _vm._s(
                                                                        _vm.formatDuration(
                                                                          stg.durationDays,
                                                                          stg.durationHours
                                                                        )
                                                                      ) +
                                                                      ")\n                                                "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              si <
                                                              record
                                                                .stageHistory
                                                                .length -
                                                                1
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "stage-flow__arrow",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "→"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            3341387324
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ])
                            : _c("div", { staticClass: "mini-empty" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "task_reports.no_timeline_data_for_any_agent"
                                    )
                                  )
                                ),
                              ]),
                        ]
                      : !_vm.timelineUserId
                      ? _c(
                          "div",
                          { staticClass: "tl-empty-state" },
                          [
                            _c("a-icon", {
                              staticClass: "tl-empty-state__icon",
                              attrs: { type: "team" },
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "tl-empty-state__text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "task_reports.select_agent_to_view_timeline"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-divider",
                              { staticClass: "tl-empty-state__divider" },
                              [_vm._v(_vm._s(_vm.$t("task_reports.timeline")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                staticClass: "tl-empty-state__btn",
                                attrs: {
                                  type: "primary",
                                  ghost: "",
                                  icon: "bar-chart",
                                },
                                on: { click: _vm.loadAllTimelines },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t(
                                        "task_reports.calculate_for_all_agents"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-row section-row--cards" }, [
      _c("div", { staticClass: "skel-card" }, [
        _c("div", { staticClass: "skel-line skel-line--lg" }),
        _c("div", { staticClass: "skel-line skel-line--sm" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "skel-card" }, [
        _c("div", { staticClass: "skel-line skel-line--lg" }),
        _c("div", { staticClass: "skel-line skel-line--sm" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skel-section" }, [
      _c("div", { staticClass: "skel-section__head" }),
      _c("div", { staticClass: "skel-row" }),
      _c("div", { staticClass: "skel-row" }),
      _c("div", { staticClass: "skel-row skel-row--short" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skel-section" }, [
      _c("div", { staticClass: "skel-section__head" }),
      _c("div", { staticClass: "skel-row" }),
      _c("div", { staticClass: "skel-row skel-row--short" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }